import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Image from 'common/image/Image';
import Link from 'router/Link';

const NewsVideo = ({
    className,
    description,
    imageID,
    subtitle,
    title,
    videoURL,
}) => (
    <div className={classNames('NewsVideo', className)}>
        <Link
            className="NewsVideo-hover"
            forceAnchor
            to={videoURL}
            target="_blank"
            rel="noopener noreferrer"
        >
            <Image
                cloudinaryImageId={`consumer-web-spa/developers/press/${imageID}`}
                height={218}
                quality={95}
                width={327}
            />
        </Link>
        <h2 className="Typography-developers-h2 NewsVideo-heading">
            {title}:<br />
            {subtitle}
        </h2>
        <p
            className="Typography-developers-description"
            dangerouslySetInnerHTML={{__html: description}}
        />
        <Link
            className="NewsVideo-link"
            forceAnchor
            to={videoURL}
            target="_blank"
            rel="noopener noreferrer"
        >
            <Image
                cloudinaryImageId="consumer-web-spa/developers/press/play"
                height={29}
                quality={95}
                width={24}
            />
            Watch Video
        </Link>
    </div>
);

NewsVideo.propTypes = {
    className: PropTypes.string,
    description: PropTypes.string,
    imageID: PropTypes.string,
    subtitle: PropTypes.string,
    title: PropTypes.string,
    videoURL: PropTypes.string,
};

export default NewsVideo;
